import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2r3dcp0q2: FaireProductEntity = {
  token: "p_c2r3dcp0q2",
  type: "product",
  name: "Ogre Sauce - All-Natural Craft BBQ Sauce",
  brandToken: "b_aay95qmjim",
  brandName: "Ogre Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/f85511c36465ddb51fecc332ed67dcda44e22bd6a64681fde4f1d90e3860061b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/247971f87d7524f477c803feff6b79743adaa58346dbd54b4f65415979d85062.jpeg",
    "https://cdn.faire.com/fastly/020380c9e733d83ca1b063043aab1d44f0e48e81670f34490c1ebed7d06d7195.jpeg",
    "https://cdn.faire.com/fastly/53e4698704c31336324dd40344ddd35832e591ce4bafcce5c2019245d98b9b50.jpeg",
    "https://cdn.faire.com/fastly/0681301188b9af09eaaaebc35d674d6bc0b3892874c08352799074e23fbb7e79.jpeg",
    "https://cdn.faire.com/fastly/335d97350193a19386b30ed1f88be8368d9fceaee56b69ab687168d09474e51f.jpeg",
    "https://cdn.faire.com/fastly/df2222f9c9e8801704556fd50869cb26482a2254d114eac60595b2af84e37676.jpeg",
    "https://cdn.faire.com/fastly/5f6344281b0804cc5709a7a78263a63f087ae847f09cd54ad8cdb448ce925ac8.jpeg",
    "https://cdn.faire.com/fastly/6c02ad6658bcb5f4b6bc5b4b72ec63523f4b6c68987a9748c924575c87e24b71.jpeg",
    "https://cdn.faire.com/fastly/494f64eab4b2b4b5967f08c4c0f98aaba1ef43074e720e255358ff529991202d.jpeg",
  ],
  priceDollars: 4.99,
  description:
    "12 - 16 oz glass bottles - Heat Level: Mild\nAll-Natural - Gluten-Free - No Preservatives - No High Fructose Corn Syrup\n\nIf the name alone doesn’t get your attention, then the bold flavors of this BBQ sauce certainly will. Ogre Sauce is the perfect blend of Carolina sauce traditions: Eastern NC Vinager, Western NC Tomato, and SC Mustard!\n\nWhile it’s great on pulled pork, ribs, or any other barbecue, it also shines when you discover that it’s just as good on almost everything else. Pair it with your grilled veggies, burgers, oysters, or use it as a dip and discover why this truly is an incredibly versatile, cooking essential.",
  tags: [],
  msrpDollars: 9.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:08.895Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
